<template>
  <div class="dynamic-qrcode-display">
    <div class="card">
      <div class="header">
        <div class="title">{{ signInfo.course }} - 签到二维码</div>
        <div class="subtitle">{{ signInfo.site }}</div>
      </div>
      <div class="qrcode-container" v-loading="loading" element-loading-text="二维码加载中...">
        <div class="qrcode-wrapper">
          <QrcodeContainer
            ref="qrcodeCont"
            class="qrcode-image"
            :width="qrcodeSize"
            :height="qrcodeSize"
            :text="qrcodeText"
          ></QrcodeContainer>
        </div>
        <div class="countdown">
          <div class="progress-wrapper">
            <el-progress :percentage="countdownPercentage" :show-text="false"></el-progress>
          </div>
          <div class="time">{{ countdownText }}</div>
        </div>
      </div>
      <div class="info">
        <div class="time-range">
          <div>签到开始: {{ signInfo.signStartDate || '未设置' }}</div>
          <div>签到结束: {{ signInfo.signEndDate || '未设置' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeContainer from '../../../../../../../elements/QrcodeContainer.vue'

export default {
  name: 'DynamicQrcodeDisplay',
  components: {
    QrcodeContainer
  },
  props: {
    signInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      qrcodeSize: 200,
      loading: false,
      qrcodeUrl: '',
      signature: '',
      refreshInterval: null,
      countdownTimer: null,
      countdown: 10,
      currentCountdown: 10
    }
  },
  computed: {
    qrcodeText () {
      if (this.signature) {
        return this.qrcodeUrl + this.signInfo.id + '/' + this.signature
      }
      return ''
    },
    countdownPercentage () {
      return (this.currentCountdown / this.countdown) * 100
    },
    countdownText () {
      return `${this.currentCountdown}秒后刷新`
    }
  },
  methods: {
    refreshQrcode () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/query/clazz/refreshSignDynamicQrcode',
        method: 'post',
        data: this.$qs.stringify({
          signId: this.signInfo.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data.responseCode) {
            case 'SUCCESS': {
              this.qrcodeUrl = response.data.qrcodeUrl
              this.signature = response.data.signature
              this.startCountdown()
              break
            }
            default: {
              this.$message.warning(response.data.message || '获取二维码失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    startCountdown () {
      this.currentCountdown = this.countdown
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }
      this.countdownTimer = setInterval(() => {
        this.currentCountdown--
        if (this.currentCountdown <= 0) {
          clearInterval(this.countdownTimer)
          this.refreshQrcode()
        }
      }, 1000)
    },
    setupRefreshInterval () {
      this.refreshQrcode()
    },
    clearTimers () {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval)
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }
    }
  },
  mounted () {
    this.setupRefreshInterval()
  },
  beforeDestroy () {
    this.clearTimers()
  }
}
</script>

<style lang="scss">
.dynamic-qrcode-display {
  .card {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;

    .header {
      text-align: center;
      margin-bottom: 20px;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #303133;
      }

      .subtitle {
        font-size: 14px;
        color: #606266;
        margin-top: 5px;
      }
    }

    .qrcode-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;

      .qrcode-wrapper {
        margin-bottom: 15px;
      }

      .qrcode-image {
        width: 200px;
        height: 200px;
        background-color: #fafafa;
        padding: 10px;
        border: 1px solid #ebeef5;
        box-sizing: border-box;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .countdown {
        width: 100%;
        max-width: 200px;

        .progress-wrapper {
          margin-bottom: 5px;
        }

        .time {
          text-align: center;
          font-size: 12px;
          color: #909399;
        }
      }
    }

    .info {
      .time-range {
        font-size: 14px;
        color: #606266;
        text-align: center;

        div {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
